<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>{{icon}}</v-icon>
      <h2 class="title ml-2">{{title}}</h2>
    </v-card-title>
    <v-card-text>
      <v-form ref="data" v-if="value">
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="value.tipo"
              :items="tipos"
              label="Tipo"
              :error-messages="errTipo"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="value.anho"
              type="number"
              label="Año"
              :error-messages="errFecha"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-text-field
          v-model="value.titulo"
          label="Título"
          :error-messages="errTitulo"
        ></v-text-field>
        <v-file-input
          label="Imagen 120px X 200px"
          v-model="value.imagen"
          show-size
          accept="image/*"
          :error-messages="errImagen"
        ></v-file-input>
        <v-row v-if="value.img" justify="center">
          <v-card>
            <v-card-text>
              <v-img
                :src="value.img"
                max-width="300"
                max-height="200"
              ></v-img>
            </v-card-text>
          </v-card>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        Cerrar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="save()">
        <v-icon left>fas fa-save</v-icon>
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import tipos from '../helpers/tipos'
export default {
  name: 'edit-libro',
  props: ['icon', 'title', 'value'],
  data () {
    return {
      tipos
    }
  },
  computed: {
    errTipo () {
      const errs = []
      if (!this.$v.value.tipo.$dirty) return errs
      !this.$v.value.tipo.required && errs.push('El título es requerido')
      return errs
    },
    errAnho () {
      const errs = []
      if (!this.$v.value.fecha.$dirty) return errs
      !this.$v.value.fecha.required && errs.push('La fecha es requerida')
      return errs
    },
    errTitulo () {
      const errs = []
      if (!this.$v.value.titulo.$dirty) return errs
      !this.$v.value.titulo.required && errs.push('El título es requerido')
      return errs
    },
    errImagen () {
      const errs = []
      if (!this.$v.value.imagen.$dirty) return errs
      !this.$v.value.imagen.required && errs.push('La imagen es requerida')
      return errs
    }
  },
  methods: {
    save () {
      this.$v.value.$touch()
      if (!this.$v.value.$invalid) {
        this.$emit('save')
      }
    },
    reset () {
      this.$refs['data'].reset()
      this.$v.value.$reset()
    }
  },
  validations: {
    value: {
      tipo: { required },
      anho: { required },
      titulo: { required },
      imagen: { required }
    }
  }
}
</script>
